import {
    PERFORMANCE_EMPLOYEE_FETCHING,
    PERFORMANCE_EMPLOYEE_FAILED,
    PERFORMANCE_EMPLOYEE_SUCCESS
} from "../actions/types";
  
const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};
  
export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case PERFORMANCE_EMPLOYEE_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case PERFORMANCE_EMPLOYEE_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case PERFORMANCE_EMPLOYEE_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
}
  